<script async setup lang="ts">
import { Carousel, Slide, Navigation } from 'vue3-carousel';
import EventPreview from '../preview/EventPreview.vue';

import { EventEntity } from '@/entities/interfaces/events';
import { useViewStore } from '@/stores/view.store';

const viewStore = useViewStore();
const view = viewStore.getViewType;

defineProps<{
  events: EventEntity[];
}>();
</script>

<template>
  <Carousel
    :items-to-show="
      view == 'mobile' ? 1 : events?.length < 3 ? events?.length : 3
    "
    :style="
      (view != 'mobile' && events.length > 3) ||
      (view == 'mobile' && events.length > 1)
        ? 'margin-bottom: 88px;'
        : ''
    "
    snapAlign="center"
  >
    <Slide v-for="event in events" :key="event.id">
      <EventPreview :event="event" />
    </Slide>

    <template #addons>
      <Navigation
        v-if="
          (view != 'mobile' && events.length > 3) ||
          (view == 'mobile' && events.length > 1)
        "
      />
    </template>
  </Carousel>
</template>

<style scoped lang="scss"></style>
